import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EndPointService } from 'src/app/core/services/end-point.service';
import { ITokenRequestData } from '../models/auth.interfaces';
import { StudentRoleSettings, UserLevel, UserLevelEnum } from '../models/UserData';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _baseUrl = '/api/auth/';
  _userRoles = 'userroles';
  _switchrole = 'switchrole';
  _userRolesForHr = 'userrolesforhr'; //api/framework/userrolesforhr
  _setDefaultRoleForEmployee = 'setdefaultroleforemployee';
  _InactiveUserRolesForHr = 'inactiveuserrolesforhr';
  constructor(
    private _endPointService: EndPointService,
    private _http: HttpClient
  ) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<StudentRoleSettings>(
      'user_roles_get',
      `${this._baseUrl}${this._userRoles}`,
      true
    );

    this._endPointService.registerEndPoint<StudentRoleSettings>(
      'user_roles_for_hr_get',
      `${this._baseUrl}${this._userRolesForHr}`,
      true
    );
    this._endPointService.registerEndPoint<StudentRoleSettings>(
      'setdefaultroleforemployee',
      `${this._baseUrl}${this._setDefaultRoleForEmployee}`,
      false
    );
    this._endPointService.registerEndPoint<any>(
      'switch_role',
      `${this._baseUrl}${this._switchrole}`,
      false
    );
    this._endPointService.registerEndPoint<UserLevel>(
      'user_inactive_roles_for_hr_get',
      `${this._baseUrl}${this._InactiveUserRolesForHr}`,
      true
    );
    this._endPointService.registerEndPoint<boolean>(
      'is_2fa_granted',
      `${this._baseUrl}is2FAGranted`,
      true
    );
  }

  public getUserRoles(fetch?: boolean): Observable<StudentRoleSettings> {
    return this._endPointService.call<StudentRoleSettings>(
      'user_roles_get',
      null,
      fetch
    );
  }
  //rolesoverview
  public getUserRolesForHR(
    employeeId: number,
    fetch?: boolean
  ): Observable<StudentRoleSettings> {
    return this._endPointService.call<StudentRoleSettings>(
      'user_roles_for_hr_get',
      employeeId,
      fetch
    );
  }
  public SetDefaultRoleForEmployee(
    employeeId: number,
    roleid: number
  ): Observable<any> {
    return this._endPointService.call<any>('setdefaultroleforemployee', {
      EmployeeId: employeeId,
      RoleId: roleid,
    });
  }

  public getInactieveUserRolesForHR(
    employeeId: number,
    fetch?: boolean
  ): Observable<StudentRoleSettings> {
    return this._endPointService.call<StudentRoleSettings>(
      'user_inactive_roles_for_hr_get',
      employeeId,
      fetch
    );
  }
  //rolesoverview

  public switchUserRole(
    role: UserLevelEnum,
    tokenData: ITokenRequestData,
    coupledStudentId?: number
  ): Observable<any> {
    return this._endPointService.call<any>('switch_role', {
      Level: role,
      LoginKey: tokenData.loginKey,
      SecurityCode: tokenData.securityCode,
      CoupledStudentId: coupledStudentId,
    });
  }

  public getUserRole(): Observable<UserLevel> {
    return this._http
      .post<UserLevel>(`${this._baseUrl}role`, null)
      .pipe(catchError(this.errorHandler));
  }

  public getAllRoles(): Observable<Array<UserLevel>> {
    return this._http
      .post<Array<UserLevel>>(`${this._baseUrl}allroles`, null)
      .pipe(catchError(this.errorHandler));
  }

  public isTwoFactorAuthenticationGranted(tokenData: ITokenRequestData): Observable<boolean> {
    return this._endPointService.call<any>('is_2fa_granted', {
      LoginKey: tokenData.loginKey,
      SecurityCode: tokenData.securityCode
    });
  }

  private errorHandler(error: HttpErrorResponse): Observable<never> {
    return throwError(error.message || 'Server Error');
  }
}
